<ion-list>
	<ng-container *ngFor="let menu of MenuData">

		<!-- RENDERIZA ITENS HEADER COM CHILDREN
		Renderiza item com submenu.
		O Item com submenu nao pode gerar navegação, mas sim, deve expandir os seus submenus.-->
		<ion-item class="menu ion-no-lines" *ngIf="menu?.HasSubMenus" routerLinkActive="active"
			(click)="OnItemMenuClick(menu)" detail="false" title="{{ menu?.ResourceName | translate }}">
			<ion-icon slot="start" [name]="menu?.Icon" class="ion-no-margin"></ion-icon>
			<ion-icon slot="end" [name]="menu.IconToggleShowSubMenus" class="ion-no-margin"></ion-icon>
			<ion-label>{{ menu?.ResourceName | translate }}</ion-label>
		</ion-item>

		<!-- RENDERIZA ITENS MENU SEM CHILDREN
		Renderiza item sem submenus.
		O Item sem submenu gera navegação e provaca a alteração de state.
		Deve possuir tambem o estado de activo ou desativo em funcao do state activo.-->
		<!-- [queryParams]="menu?.HasSubMenus ? {} : {'id': menu?.Id, 'title': menu?.ResourceName}" -->
		<!-- [queryParams]="{idmenu: menu?.Id}" -->
		<ion-item class="menu" *ngIf="!menu?.HasSubMenus" [routerDirection]="'root'"
			[routerLink]=" menu?.HasSubMenus ? [] : [menu?.IdComponent]"
			[queryParams]="menu?.IdNavigationType === 1 ? {id: menu?.Id}: null" routerLinkActive="active"
			(click)="OnItemMenuClick(menu)" detail="false" title="{{ menu?.ResourceName | translate }}"
			class="ion-no-lines">
			<ion-icon slot="start" [name]="menu?.Icon" class="ion-no-margin"></ion-icon>
			<ion-label>{{ menu?.ResourceName | translate }}</ion-label>
		</ion-item>

		<!-- RENDERIZA GROUPO DE ITENS DE UM SUBMENU
		Renderiza items de um submenu.
		O Item gera navegação e provaca a alteração de state.
		Deve possuir tambem o estado de activo ou desativo em funcao do state activo.
		O item so pode ser visivel se o seu menu parent estiver marcado para mostrar os children.-->
		<!-- [queryParams]="{'id': submenu?.Id, 'title': submenu?.ResourceName}" -->
		<!-- [queryParams]="{idmenu: submenu?.Id}" -->
		<ng-container *ngFor="let submenu of menu.SubMenus">
			<ion-item class="submenu ion-no-lines" [routerDirection]="'root'" [routerLink]="[submenu?.IdComponent]"
				routerLinkActive="active" #rla="routerLinkActive" (click)="OnItemMenuClick(submenu)"
				[hidden]="!menu?.ShowSubMenus" detail="false" title="{{ submenu?.ResourceName | translate }}">
				<ion-icon slot="start" [name]="submenu?.Icon" class="ion-no-margin"></ion-icon>
				<ion-label>{{ submenu?.ResourceName | translate }}</ion-label>
			</ion-item>
		</ng-container>
	</ng-container>

</ion-list>